'use client';
import { Spacer } from '@/shared/components/parts/Spacer';
import { ButtonPrimary } from '@/shared/components/parts/buttons/ButtonPrimary';
import { ButtonSecondary } from '@/shared/components/parts/buttons/ButtonSecondary';
import { useGuideFeedback } from './index.hook';

export const GuideFeedback: React.FC = () => {
  const { status, send } = useGuideFeedback();

  return (
    <div>
      <Spacer spacing={4} />
      <div className="h-[1px] w-full border-[1px] border-t border-main-10" />
      <Spacer spacing={8} />
      {status === 'READY' && (
        <>
          <div className="text-center text-base2 font-bold text-main-100">
            この情報は役に立ちましたか？
          </div>
          <Spacer spacing={4} />
          <div className="flex w-full justify-center gap-4">
            <div className="w-24">
              <ButtonPrimary
                text="はい"
                width="full"
                onClick={() => send(true)}
              />
            </div>
            <div className="w-24">
              <ButtonSecondary
                text="いいえ"
                width="full"
                onClick={() => send(false)}
              />
            </div>
          </div>
        </>
      )}
      {status === 'SEND' && (
        <div className="text-center text-base2 font-bold text-main-100">
          貴重なご意見をお寄せいただき
          <br />
          ありがとうございます。
        </div>
      )}
    </div>
  );
};
